import { get } from "lodash";
import { FileItem } from "../../polymer/Document.model"
import { StageDMessageInfo, StageDocumentsInfo } from "../stage-d/Review-Application.class"
import { SubmitDocuments } from "../CooSubmission.class";
import { SolicitorCorrespondenceAdditionalInfo } from "./SolicitorCorrespondenceRequest.class";

export type SubmissionType = "message" | "document" | "completion" | "submission"
export class GroupSubmittedDocument {
  title   : string;
  submitted_date_time: string;
  submitted_by: string;
  documents: FileItem[];
  additional_info: SolicitorCorrespondenceAdditionalInfo;

  constructor(initial?:any){
    this.title         = get(initial, 'title', false);
    this.submitted_date_time          = get(initial, 'submitted_date_time', false);
    this.submitted_by  = get(initial, 'submitted_by', "");
    this.documents = get(initial, 'documents', undefined);
    this.additional_info = get(initial, 'additional_info', {})
  }
}

export type SolicitorSubmission = {
  message_info?: StageDMessageInfo[],
  folders?: StageDocumentsInfo[],
  additional_documents?: SubmitDocuments[],
  grouped_additional_documents?: GroupSubmittedDocument[]
}